/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Users_DescriptionInputs */

const es_walkthrough_admin_users_description = /** @type {(inputs: Walkthrough_Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitá nuevos usuarios, editá sus perfiles y gestioná roles y permisos. Podés marcar usuarios como administradores y eliminar cuentas.`)
};

const en_walkthrough_admin_users_description = /** @type {(inputs: Walkthrough_Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite new users, edit their profiles, and manage roles and permissions. You can mark users as admins and delete accounts.`)
};

/**
* | output |
* | --- |
* | "Invite new users, edit their profiles, and manage roles and permissions. You can mark users as admins and delete accounts." |
*
* @param {Walkthrough_Admin_Users_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_users_description = /** @type {((inputs?: Walkthrough_Admin_Users_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Users_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_users_description(inputs)
	return en_walkthrough_admin_users_description(inputs)
});
export { walkthrough_admin_users_description as "walkthrough.admin_users_description" }